export default "__VITE_ASSET__DpCNz9Ju__"